<script setup lang="ts">
// TODO :: TASK-2103 - Should be promoted to a molecule
import type { CartAnimal } from '../../../interfaces';
import type { AnimalAvatarSize, Gender } from '@AnimalModule';

defineEmits<{
  onRemoveAnimal: [];
}>();

withDefaults(
  defineProps<{
    animal: CartAnimal;
    hasDelete?: boolean;
    nameSize?: 'text-sm' | 'text-md' | 'text-lg' | 'text-xl' | 'text-2xl' | 'text-3xl' | 'text-4xl' | 'text-5xl';
    size?: AnimalAvatarSize;
    type?: 'vertical' | 'horizontal';
  }>(),
  {
    nameSize: 'text-sm',
    size: '3xl',
    type: 'vertical',
  }
);
</script>

<template>
  <div class="relative">
    <Button
      v-if="hasDelete"
      outlined
      class="absolute -top-2 left-[-5px] h-5 w-5 border-none bg-red-50 p-2"
      icon="pi pi-trash text-sm"
      severity="danger"
      @click="$emit('onRemoveAnimal')"
    />

    <RouterLink
      :class="[type === 'vertical' ? 'inline-block text-center' : 'flex items-center gap-2']"
      :to="`/shelter/animal-profile/${animal._id}`"
    >
      <AAvatar
        :size
        :src="animal.photo"
        :gender="animal.gender as Gender"
      />

      <span :class="['af-link font-bold', nameSize]">
        {{ animal.animal_name }}
      </span>
    </RouterLink>
  </div>
</template>
